import { architectApi } from './api';
import type { Spec } from './types';

/** The current SVG endpoint and project metadata are separate reads. Verify a
 * stable version/spec after the SVG read before treating that poster as reviewed.
 * A later edit is still rejected by the approve endpoint's version comparison. */
export async function loadArchitectureSnapshotSvg(projectId: string, spec: Spec, versionId: string | null) {
  const svg = await architectApi.getSvgText(projectId);
  // Older projects may predate version records; preserve their existing reads.
  if (versionId) {
    const confirmed = await architectApi.getProject(projectId);
    if (confirmed.versions?.[0]?.id !== versionId || JSON.stringify(confirmed.spec) !== JSON.stringify(spec)) {
      throw new Error('The architecture changed while loading. Reload before reviewing.');
    }
  }
  return svg;
}
